const smsStatuses = {
  SENDING: "SENDING",
  DONE: "DONE",
};

export default smsStatuses;
